import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'previousDates',
    standalone: true
})
export class PreviousDatesPipe implements PipeTransform {
    transform(items: any): any {
        const arrayToReturn: any = [];
        for (let i = 0; i < items.length; i++) {
            const date = items[ i ].startTime;
            if (moment(date).isBefore(moment())) {
                arrayToReturn.push(items[ i ]);
            }
        }
        return arrayToReturn;
    }
}
